import React, { useEffect, useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { FuelFlex } from '@frete.com/fuel-station-react';
import useAmplitude from '@hooks/useAmplitude';
import useLoadProposals from '@hooks/useLoadProposals';
import { createJourney } from '@services/journeys';
import Toast from '@components/ui/Toast';
import useLoadJourneys from '@hooks/useLoadJourneys';
import { CreateJourneyType } from './schema';
import FieldTrucker from './FieldTrucker';
import FieldProduct from './FieldProduct';
import FieldAddress from './FieldAddress';
import Actions from './Actions';
import { FormPropsInterface } from './FormTypes';
import * as Styled from './FormStyles';

function Form({ actionsInnerRef, onCancel, onSuccess }: FormPropsInterface) {
  const { amplitudeEvent } = useAmplitude();
  const { fetchJourneys } = useLoadJourneys('lazy');
  const { fetchProposals } = useLoadProposals();
  const { handleSubmit, reset } = useFormContext<CreateJourneyType>();
  const [toastIsShow, setToastIsShow] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  function handleSuccess() {
    fetchJourneys({ page: 1 });
    fetchProposals({ page: 1 });
    onSuccess();
    reset();
  }

  function handleError() {
    setToastIsShow(true);
    amplitudeEvent('journey_create_toast_error_show');
  }

  function handleFinally() {
    setIsLoading(false);
  }

  function onSubmit(data: CreateJourneyType) {
    if (!isLoading) {
      setIsLoading(true);

      createJourney(data)
        .then(handleSuccess)
        .catch(handleError)
        .finally(handleFinally);
    }
  }

  useEffect(() => {
    amplitudeEvent('journey_create_form_viewed');
  }, []);

  return (
    <Styled.Wrapper>
      <form
        data-testid="form-createJourney"
        onSubmit={handleSubmit((data) => onSubmit(data))}
      >
        <FuelFlex defaultProps={{ flexDirection: 'column', gap: 'km6' }}>
          <FieldTrucker />
          <FieldProduct />
          <FieldAddress flow="pickup" />
          <FieldAddress flow="delivery" />
          <Actions
            innerRef={actionsInnerRef}
            isLoading={isLoading}
            onCancel={onCancel}
          />
        </FuelFlex>
      </form>
      <Toast
        isShow={toastIsShow}
        title="Não foi possível criar a viagem"
        message="Tente novamente mais tarde"
        severity="error"
        onClose={() => setToastIsShow(false)}
      />
    </Styled.Wrapper>
  );
}

export default Form;
